import { Component, Input } from '@angular/core';

@Component({
    selector: 'canvas-admin-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: false
})
export class NavComponent {
  @Input() backgroundColor = '#ffffff';
}
